/**
 * @generated SignedSource<<6562520081aa8e7d6241bce95aad2b75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ActionItemIntegrationSyncStatus = "CREATING_EXTERNALLY" | "DONE_SYNCING_EXTERNALLY" | "FAILED_TO_SYNC_EXTERNALLY" | "SENDING_UPDATE_EXTERNALLY";
export type AgendaBuilderTone = "CASUAL" | "FORMAL" | "NEUTRAL";
export type AncestryRelationship = "ANCESTOR" | "DESCENDANT" | "DIRECT_REPORT" | "MANAGER" | "OTHER" | "SELF" | "SIBLING";
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
export type EventType = "OCCURRENCE" | "RECURRING" | "SINGLE";
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
export type MeetingAttachmentProvider = "GOOGLE" | "ZOOM";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type ResponseStatusChoices = "accepted" | "declined" | "needsAction" | "none" | "notResponded" | "organizer" | "tentative" | "tentativelyAccepted";
export type StatusChoices = "busy" | "cancelled" | "confirmed" | "free" | "needsAction" | "oof" | "tentative" | "unknown" | "workingElsewhere";
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type NoteCard_note$data = {
  readonly actionItemsCarriedForward: boolean;
  readonly asanaActionItems: ReadonlyArray<{
    readonly asanablocklink: {
      readonly externalId: string | null;
      readonly id: string;
      readonly project: {
        readonly externalId: string | null;
        readonly id: string;
        readonly name: string;
      };
    } | null;
    readonly blockId: string;
    readonly blockKey: string;
  }>;
  readonly attachments: ReadonlyArray<{
    readonly dimensions: {
      readonly height: number;
      readonly width: number;
    } | null;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AttachmentPreviewAttachment">;
  }>;
  readonly canUnlockNote: boolean;
  readonly collapsedBlockKeys: ReadonlyArray<string>;
  readonly comments: ReadonlyArray<{
    readonly blockKey: string;
    readonly count: number;
    readonly users: ReadonlyArray<{
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isExternal: boolean;
    }>;
  }>;
  readonly createdAt: string | null;
  readonly event: {
    readonly attendees: ReadonlyArray<{
      readonly __typename: "Attendee";
      readonly email: string;
      readonly fullName: string | null;
      readonly image: string | null;
      readonly invitable: boolean;
      readonly user: {
        readonly id: string;
        readonly isActive: boolean;
        readonly isConfigured: boolean;
        readonly isTopUser: boolean;
      } | null;
    } | null>;
    readonly calendar: {
      readonly id: string;
    };
    readonly conferenceCalls: ReadonlyArray<{
      readonly phoneNumber: string | null;
      readonly pin: string | null;
      readonly provider: ConferenceCallProvider;
      readonly url: string;
    }>;
    readonly end: string | null;
    readonly guid: string;
    readonly id: string;
    readonly isAllDay: boolean;
    readonly isHidden: boolean | null;
    readonly isOrganizer: boolean | null;
    readonly location: string | null;
    readonly recurrenceRule: ReadonlyArray<string | null> | null;
    readonly start: string | null;
    readonly status: StatusChoices;
    readonly title: string;
    readonly type: EventType;
    readonly userResponseStatus: ResponseStatusChoices | null;
    readonly " $fragmentSpreads": FragmentRefs<"AttachmentsOrConference_event" | "JoinConferenceButton_event">;
  } | null;
  readonly eventAttachments: ReadonlyArray<{
    readonly fileId: string;
    readonly fileType: string;
    readonly provider: MeetingAttachmentProvider;
    readonly title: string | null;
    readonly url: string;
  }> | null;
  readonly eventEnd: string | null;
  readonly eventGuid: string | null;
  readonly eventStart: string | null;
  readonly eventTitle: string | null;
  readonly externalUsers: ReadonlyArray<{
    readonly __typename: "User";
    readonly email: string;
    readonly firstName: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
    readonly internalAttributes: {
      readonly invitable: boolean;
    } | null;
    readonly isActive: boolean;
    readonly isConfigured: boolean;
    readonly isExternal: boolean;
    readonly isGuest: boolean;
    readonly isTopUser: boolean;
    readonly type: UserType;
  }> | null;
  readonly finished: boolean;
  readonly finishedAt: string | null;
  readonly groupName: string;
  readonly hasMeetingRecordings: boolean;
  readonly id: string;
  readonly integrationLinkedActionItems: ReadonlyArray<{
    readonly actionItemIntegrationLink: {
      readonly actionItem: {
        readonly id: string;
        readonly key: string;
        readonly originalBlockId: string | null;
      };
      readonly createdAt: string | null;
      readonly id: string;
      readonly integrationData: {
        readonly __typename: "ClickupActionItemIntegrationSpecificDataNode";
        readonly externalTaskId: string;
        readonly listName: string;
        readonly status: string;
        readonly statusColor: string;
      } | {
        readonly __typename: "HubspotTaskActionItemIntegrationSpecificDataNode";
        readonly externalTaskId: string;
        readonly hubspotUrl: string;
      } | {
        readonly __typename: "LinearActionItemIntegrationSpecificDataNode";
        readonly externalIdentifier: string | null;
        readonly linearUser: {
          readonly id: string;
          readonly isConnected: boolean;
          readonly organizationUrlKey: string;
        };
        readonly statusColor: string;
        readonly statusName: string;
        readonly teamName: string;
      } | {
        readonly __typename: "MicrosoftTodoActionItemIntegrationSpecificDataNode";
        readonly externalListId: string;
        readonly externalListName: string;
        readonly externalTaskId: string;
        readonly microsoftTodoUser: {
          readonly isConnected: boolean;
        };
        readonly status: string;
      } | {
        readonly __typename: "MondayActionItemIntegrationSpecificDataNode";
        readonly externalBoardId: string;
        readonly externalBoardName: string;
        readonly externalGroupName: string;
        readonly externalTaskId: string;
        readonly mondayUser: {
          readonly accountSlug: string;
        };
        readonly status: string;
      } | {
        readonly __typename: "TrelloActionItemIntegrationSpecificDataNode";
        readonly boardName: string;
        readonly externalCardId: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly integrationProvider: IntegrationProvider;
      readonly lastSyncedError: string | null;
      readonly syncStatus: ActionItemIntegrationSyncStatus;
      readonly updatedAt: string | null;
    } | null;
    readonly id: string;
    readonly key: string;
  }>;
  readonly isLocked: boolean;
  readonly linkedActionItems: ReadonlyArray<{
    readonly hasOriginalBlock: boolean;
    readonly originalBlock: {
      readonly key: string;
      readonly note: {
        readonly id: string;
        readonly stream: {
          readonly url: string | null;
        };
      };
      readonly " $fragmentSpreads": FragmentRefs<"ActionItemData">;
    } | null;
    readonly originalBlockId: string | null;
  }>;
  readonly meetingFeedbackResponseCount: number;
  readonly meetingRecordings: ReadonlyArray<{
    readonly id: string;
    readonly isCurrentlyRecording: boolean | null;
    readonly transcript: any | null;
  }> | null;
  readonly noteTitle: string;
  readonly noteType: NoteStreamType;
  readonly noteuserSet: ReadonlyArray<{
    readonly id: string;
    readonly lastSeenAt: string | null;
    readonly user: {
      readonly __typename: "User";
      readonly email: string;
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly internalAttributes: {
        readonly invitable: boolean;
      } | null;
      readonly isActive: boolean;
      readonly isConfigured: boolean;
      readonly isExternal: boolean;
      readonly isGuest: boolean;
      readonly isTopUser: boolean;
      readonly type: UserType;
    };
  }>;
  readonly previousNote: {
    readonly pendingAgendaCount: number;
    readonly pendingTodoCount: number;
  } | null;
  readonly rawDraftJson: any;
  readonly reactions: string;
  readonly schemaVersion: number;
  readonly showAiAgendaBuilderFeatureToViewer: boolean;
  readonly stream: {
    readonly account: {
      readonly id: string;
      readonly name: string;
    };
    readonly agendaBuilderContext: string;
    readonly agendaBuilderTone: AgendaBuilderTone;
    readonly carryActionItems: boolean | null;
    readonly carryTalkingPoints: boolean | null;
    readonly displayName: string;
    readonly fromSignupForViewer: boolean;
    readonly hasExternalUsers: boolean;
    readonly id: string;
    readonly isExternal: boolean;
    readonly isMeetingFeedbackPromptEnabled: boolean;
    readonly notestreamusers: ReadonlyArray<{
      readonly user: {
        readonly email: string;
      };
    }>;
    readonly openActionItemCount: number;
    readonly otherUser: {
      readonly activeRecurring1on1Event: {
        readonly recurrenceRule: ReadonlyArray<string | null> | null;
        readonly start: string | null;
      } | null;
      readonly department: string | null;
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly internalAttributes: {
        readonly manager: {
          readonly fullName: string;
          readonly id: string;
        } | null;
        readonly suggestedTopics: ReadonlyArray<string>;
      } | null;
      readonly isActive: boolean;
      readonly isConfigured: boolean;
      readonly isGuest: boolean;
      readonly relationshipToViewer: AncestryRelationship | null;
      readonly title: string | null;
      readonly type: UserType;
    } | null;
    readonly schedulingMeetingAssistantAutomationIsActive: boolean;
    readonly template: {
      readonly id: string;
      readonly upgradedProseDoc: any;
    } | null;
    readonly templateHasBeenChanged: boolean | null;
    readonly type: NoteStreamType;
    readonly typeTag: string;
    readonly watching: boolean | null;
  };
  readonly talkingPointsCarriedForward: boolean;
  readonly updatedAt: string | null;
  readonly url: string | null;
  readonly version: number;
  readonly viewerAgendaGeneratorBannerDismissed: boolean;
  readonly viewerCanEdit: boolean;
  readonly viewerDismissedCarryForwardActionItemBanner: boolean;
  readonly viewerDismissedCarryForwardTalkingPointBanner: boolean;
  readonly viewerSentMeetingFeedback: boolean;
  readonly viewerShowAutomationTimeSaverBanner: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowHooks_useAskFellowButton_note" | "AttachmentsRelay_note" | "EditTemplateMenuItem_note" | "FloatingRecordingControls_note" | "MeetingContainerTabs_note" | "MeetingPhaseContext_note" | "MeetingRecordingBanner_RecordMeetingButton_note" | "MeetingSummaryBanner_IfMeetingSummaryBannerHidden_note" | "MeetingSummaryBanner_note" | "MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note" | "NoteHeader_note" | "SendNotesModal_IncludeAISummaryFormField_note" | "SendNotesModal_note" | "SuggestedActions_note" | "TranscriptModal_note">;
  readonly " $fragmentType": "NoteCard_note";
};
export type NoteCard_note$key = {
  readonly " $data"?: NoteCard_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteCard_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalBlockId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalTaskId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceRule",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invitable",
  "storageKey": null
},
v27 = [
  (v10/*: any*/),
  (v0/*: any*/),
  (v15/*: any*/),
  (v17/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v25/*: any*/),
  (v16/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserInternalAttributes",
    "kind": "LinkedField",
    "name": "internalAttributes",
    "plural": false,
    "selections": [
      (v26/*: any*/)
    ],
    "storageKey": null
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteCard_note",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawDraftJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventGuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finished",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUnlockNote",
      "storageKey": null
    },
    {
      "alias": "noteTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schemaVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collapsedBlockKeys",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showAiAgendaBuilderFeatureToViewer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingAttachment",
      "kind": "LinkedField",
      "name": "eventAttachments",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileId",
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileType",
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "linkedActionItems",
      "args": [
        {
          "kind": "Literal",
          "name": "linkedOnly",
          "value": true
        }
      ],
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "actionItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasOriginalBlock",
          "storageKey": null
        },
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteBlock",
          "kind": "LinkedField",
          "name": "originalBlock",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "note",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "stream",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ActionItemData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "actionItems(linkedOnly:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrentlyRecording",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transcript",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "asanaActionItems",
      "args": [
        {
          "kind": "Literal",
          "name": "asanaOnly",
          "value": true
        }
      ],
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "actionItems",
      "plural": true,
      "selections": [
        {
          "alias": "blockId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": "blockKey",
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AsanaBlockLinkNode",
          "kind": "LinkedField",
          "name": "asanablocklink",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AsanaProjectNode",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/)
              ],
              "storageKey": null
            },
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "actionItems(asanaOnly:true)"
    },
    {
      "alias": "integrationLinkedActionItems",
      "args": [
        {
          "kind": "Literal",
          "name": "integrationConnectedOnly",
          "value": true
        }
      ],
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "actionItems",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ActionItemIntegrationLinkNode",
          "kind": "LinkedField",
          "name": "actionItemIntegrationLink",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "NoteBlock",
              "kind": "LinkedField",
              "name": "actionItem",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v0/*: any*/),
                (v7/*: any*/)
              ],
              "storageKey": null
            },
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "syncStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastSyncedError",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationProvider",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "integrationData",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "listName",
                      "storageKey": null
                    },
                    (v12/*: any*/),
                    (v13/*: any*/)
                  ],
                  "type": "ClickupActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalCardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "boardName",
                      "storageKey": null
                    }
                  ],
                  "type": "TrelloActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalGroupName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalBoardName",
                      "storageKey": null
                    },
                    (v12/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MondayUserNode",
                      "kind": "LinkedField",
                      "name": "mondayUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountSlug",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "MondayActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalIdentifier",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "teamName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "statusName",
                      "storageKey": null
                    },
                    (v13/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LinearUserNode",
                      "kind": "LinkedField",
                      "name": "linearUser",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v14/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "organizationUrlKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "LinearActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalListId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalListName",
                      "storageKey": null
                    },
                    (v12/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MicrosoftTodoUserNode",
                      "kind": "LinkedField",
                      "name": "microsoftTodoUser",
                      "plural": false,
                      "selections": [
                        (v14/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "MicrosoftTodoActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hubspotUrl",
                      "storageKey": null
                    }
                  ],
                  "type": "HubspotTaskActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "actionItems(integrationConnectedOnly:true)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditTemplateMenuItem_note"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "watching",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "typeTag",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateHasBeenChanged",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "carryTalkingPoints",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "carryActionItems",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMeetingFeedbackPromptEnabled",
          "storageKey": null
        },
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasExternalUsers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fromSignupForViewer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "openActionItemCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agendaBuilderTone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agendaBuilderContext",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "schedulingMeetingAssistantAutomationIsActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteTemplateNode",
          "kind": "LinkedField",
          "name": "template",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "upgradedProseDoc",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteStreamUser",
          "kind": "LinkedField",
          "name": "notestreamusers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v17/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "otherUser",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "department",
              "storageKey": null
            },
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v15/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "relationshipToViewer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "activeRecurring1on1Event",
              "plural": false,
              "selections": [
                (v23/*: any*/),
                (v24/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserInternalAttributes",
              "kind": "LinkedField",
              "name": "internalAttributes",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "suggestedTopics",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "manager",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v18/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteUser",
      "kind": "LinkedField",
      "name": "noteuserSet",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastSeenAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v27/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "externalUsers",
      "plural": true,
      "selections": (v27/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v23/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        },
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guid",
          "storageKey": null
        },
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Calendar",
          "kind": "LinkedField",
          "name": "calendar",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ConferenceCall",
          "kind": "LinkedField",
          "name": "conferenceCalls",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phoneNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pin",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "location",
          "storageKey": null
        },
        (v24/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userResponseStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHidden",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOrganizer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAllDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Attendee",
          "kind": "LinkedField",
          "name": "attendees",
          "plural": true,
          "selections": [
            (v10/*: any*/),
            (v17/*: any*/),
            (v26/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v20/*: any*/),
                (v21/*: any*/),
                (v25/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AttachmentsOrConference_event"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JoinConferenceButton_event"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AttachmentsRelay_note"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageDimensions",
          "kind": "LinkedField",
          "name": "dimensions",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            (v29/*: any*/)
          ],
          "storageKey": null
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "AttachmentPreviewAttachment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "filename",
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "alias": "directUrl",
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "size",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageDimensions",
              "kind": "LinkedField",
              "name": "dimensions",
              "plural": false,
              "selections": [
                (v29/*: any*/),
                (v28/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "filetype",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actionItemsCarriedForward",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talkingPointsCarriedForward",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerDismissedCarryForwardActionItemBanner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerDismissedCarryForwardTalkingPointBanner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerAgendaGeneratorBannerDismissed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerSentMeetingFeedback",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingFeedbackResponseCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerShowAutomationTimeSaverBanner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "previousNote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingTodoCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingAgendaCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reactions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteCommentsData",
      "kind": "LinkedField",
      "name": "comments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "users",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v16/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FloatingRecordingControls_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AskFellowHooks_useAskFellowButton_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingRecordingBanner_RecordMeetingButton_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingPhaseContext_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingSummaryBanner_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingSummaryBanner_IfMeetingSummaryBannerHidden_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SendNotesModal_IncludeAISummaryFormField_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SuggestedActions_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SendNotesModal_note"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "public",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "TranscriptModal_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteHeader_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingContainerTabs_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "915e9aac91e98ed428aa700a44028c33";

export default node;
